import { render, staticRenderFns } from "./PonudaAkcija.vue?vue&type=template&id=6c467054"
import script from "./PonudaAkcija.vue?vue&type=script&lang=js"
export * from "./PonudaAkcija.vue?vue&type=script&lang=js"
import style0 from "./PonudaAkcija.vue?vue&type=style&index=0&id=6c467054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports